import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  hero: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    minHeight: 300,
    borderRadius: 5,
    [theme.breakpoints.up('lg')]: {
      minHeight: 450,
    },
  },
}));
